// jQueryはcdnで読み込み
// @types/jqueryを読み込んでいるのでエラーは出ないようにしている
/// <reference path='./typing.d.ts' />


/* ========================================
    sp nav
======================================== */
$(function() {
    $(".nav__sp-btn").on("click", function() {
        $(this).next("nav").toggleClass("open");
        $(this).toggleClass("open");
    });
});


/* ========================================
    back top
======================================== */
$(function(){
    var speed = 400;
    $('.backTop').click(function() {
        var position = 0;
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
    });
});

/* ========================================
    footer nav
======================================== */
$(function () {
    $(".footer__nav-toggle").on("click", function () {
        $(this).find("dt").toggleClass("open");
        $(this).find("dd").toggleClass("open");

        if ($(this).hasClass("scroll")) {
            let target = $('.footer__nav-toggle.scroll');
            let FOOTER_NAV = target.height();
            let SPEED = 400;
            let position = target.offset().top + FOOTER_NAV;
            setTimeout(function(){
                $('body,html').animate({ scrollTop: position }, SPEED, 'swing');
                return false;
            }, 100);
        }
    })
});

/* ========================================
    scroll
======================================== */
$(function() {
    var scrIn = $("#scroll__in");
    $(window).on('load scroll', function () {
        if($(this).scrollTop() > 200 && scrIn.hasClass('in') == false) {
            scrIn.addClass('in');
        }
        else if($(this).scrollTop() < 200 && scrIn.hasClass('in') == true){
            scrIn.removeClass('in');
        }
    });
});
$(function() {
    var scrOut = $("#scroll__out");
    $(window).on('load scroll', function () {
        if($(this).scrollTop() > 200 && scrOut.hasClass('out') == false) {
            scrOut.addClass('out');
        }
        else if($(this).scrollTop() < 200 && scrOut.hasClass('out') == true){
            scrOut.removeClass('out');
        }
    });
});
$(function() {
    let HEADER_HEIGHT = 100;
    let SPEED = 400;
    let $target = $('a[href^="#"]:not( .not-scroll )');
    let urlHash = location.hash;

    if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
            let target = $(urlHash);
            let position = target.offset().top - (HEADER_HEIGHT * 2);
            $('body,html').animate({ scrollTop:position }, SPEED, 'swing');
        return false;
        }, 100);
    } else {
        $target.on('click', (e) => {
            let href = $(e.currentTarget).attr('href');
            let data = $(e.currentTarget).data('top');
            let target = $(href == '#' || href == '' ? 'html' : href);
            let position = target.offset().top - (!data ? HEADER_HEIGHT : HEADER_HEIGHT * 2);
            $('body,html').animate({ scrollTop:position }, SPEED, 'swing');
            return false;
        });
    }
});

/* ========================================
    ofi
======================================== */
$(function () {
    objectFitImages('.ofi');
});


/* ========================================
    slider
======================================== */
$(function(){
    $("#top_bnr_slider").slick({
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: 0,
        prevArrow: '<div class="arrow arrow-prev"></div>',
        nextArrow: '<div class="arrow arrow-next"></div>',
        lazyLoad: 'progressive',
        pauseOnHover: true
    })
    $("#top_bnr_slider_pc").slick({
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: 0,
        prevArrow: '<div class="arrow arrow-prev"></div>',
        nextArrow: '<div class="arrow arrow-next"></div>',
        lazyLoad: 'progressive',
        pauseOnHover: true
    })
    $("#top_menu_slider").slick({
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '0',
        pauseOnHover: true,
        responsive: [{
            breakpoint: 540,
            settings: {
                slidesToShow: 1,
                centerPadding: '25%',
            }
            }
        ]
    })
    $("#top_news_slider").slick({
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '0',
        pauseOnHover: true
    })
});


/* ========================================
    protect
======================================== */
$(function() {
    $('.js-protect').aemProtectImage();

    // 記事に画像があった場合の対応
    var $aemPost = $(".aem-post");
    var $aemPostImg = $aemPost.find("img");

    if ($aemPostImg.length) {
        $aemPostImg.wrap('<span class="js-protect">');
        $aemPost.find('.js-protect').aemProtectImage();
    }

});


/* ========================================
    iziModal
======================================== */
$(function () {
    var trigger = ".inline-modal";
    var $modal = $('body').find(trigger);

    if ($modal.length) {
        $(trigger).iziModal({
            group: "inline-group",
            width: "90%",
            background: "transparent",
            overlayColor: "rgba(0, 0, 0, 0.84)"
        });
    }
});


/* ========================================
    read more
======================================== */
var itemHeights = [];
$(function(){
    $(".js-readmore-body").each(function(){
        var thisHeight = $(this).height();

        if (thisHeight <= 60) {
            $(".js-readmore-title").hide();
        }
        
        itemHeights.push(thisHeight);
        $(this).addClass("hide");
    });

    $(".js-readmore-title").click(function(){
        var index = $(this).index(".js-readmore-title");
        var addHeight = itemHeights[index];
        $(this).fadeOut().addClass("show").prev(".js-readmore-body").removeClass("hide").animate({height: addHeight},500);
    });
});